module.exports = __webpack_public_path__ + "img/IMG_1699_FoamcoreMatted_MockedUp.d715e8bf.jpg";